import {useFormik} from 'formik';
import {useState} from 'react';
import {CreateStoryParams, useBlockStories} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddStoryFormProps = {
  blockId: string;
  setOpen: (open: boolean) => void;
};

export const useAddStoryForm = ({blockId, setOpen}: UseAddStoryFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createStoryMutation} = useBlockStories({blockId});

  const onSubmit = async (values: {title: string}) => {
    setErrorMessage(null);
    try {
      const storyData: CreateStoryParams = {
        blockId,
        title: values.title,
      };
      await createStoryMutation.mutateAsync(storyData);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании истории');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Заголовок не должен превышать 256 символов').required('Заголовок обязателен'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createStoryMutation.isPending,
    submitError: createStoryMutation.error
      ? (createStoryMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
